import { forwardRef } from 'react'
import { cn } from '../../utils/cn'

const Input = forwardRef(({
  type = 'text',
  placeholder = '',
  className = '',
  disabled = false,
  error = false,
  ...props
}, ref) => {
  return (
    <input
      ref={ref}
      type={type}
      placeholder={placeholder}
      disabled={disabled}
      className={cn(
        'input',
        error && 'border-error-500 focus-visible:ring-error-500',
        className
      )}
      {...props}
    />
  )
})

Input.displayName = 'Input'

export default Input



